import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { toLoginRoute } from '@/utils/routes';
import { translate } from '@/i18n';

import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const {
      avatar,
      username
    } = storeToRefs(userStore);
    const {
      logout
    } = userStore;
    const active = ref(false);
    const handleVisibleChange = val => {
      active.value = val;
    };
    const handleCommand = async command => {
      switch (command) {
        case 'logout':
          await logout();
          await router.push(toLoginRoute(route.fullPath));
          break;
        case 'personalCenter':
          await router.push('/setting/personalCenter');
          break;
        case 'friendlyTip':
          await router.push('/friendly-tip');
          break;
      }
    };
    const __returned__ = {
      route,
      router,
      userStore,
      avatar,
      username,
      logout,
      active,
      handleVisibleChange,
      handleCommand,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});